// src/components/UI/SkipLink.jsx

import React from 'react';

/**
 * Skip Link für Barrierefreiheit
 * Ermöglicht Screenreader-Usern das Überspringen der Navigation
 */
export const SkipLink = ({ target = '#main-content', children = 'Zum Inhalt springen' }) => {
  const handleClick = (e) => {
    e.preventDefault();
    const element = document.querySelector(target);
    if (element) {
      element.focus();
      element.scrollIntoView({ behavior: 'smooth' });
      // Set tabindex temporarily if not focusable
      if (!element.hasAttribute('tabindex')) {
        element.setAttribute('tabindex', '-1');
        element.addEventListener('blur', () => {
          element.removeAttribute('tabindex');
        }, { once: true });
      }
    }
  };

  return (
    <a
      href={target}
      onClick={handleClick}
      className="
        sr-only 
        focus:not-sr-only 
        focus:fixed 
        focus:top-4 
        focus:left-4 
        focus:z-[9999] 
        focus:px-6 
        focus:py-3 
        focus:bg-[var(--accent)] 
        focus:text-[var(--bg)] 
        focus:font-semibold 
        focus:rounded-lg 
        focus:shadow-lg
        focus:outline-none
        focus:ring-2
        focus:ring-offset-2
        focus:ring-[var(--accent)]
      "
    >
      {children}
    </a>
  );
};

/**
 * Alternative Version mit custom Styling
 */
export const SkipLinkMinimal = ({ target = '#main-content' }) => (
  <a
    href={target}
    className="absolute -top-10 left-0 bg-[var(--accent)] text-[var(--bg)] px-4 py-2 z-50 transition-top focus:top-0"
  >
    Skip to content
  </a>
);

export default SkipLink;